<p class="alert alert-warning text-center" *ngIf="show"> MatrixCare Admin Tool will be unavailable on Wednesday, May 29th at 1:00am CDT for up to 2 hours.</p>
